import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../gen-src/Localize';

export const MetricTitle = (props: { metricName: string }): JSX.Element => {
  return (
    <div
      role="heading"
      aria-level={1}
      aria-label={Messages.ariaLabelMetricName()}
      data-tb-test-id="metric-title"
      style={titleStyle}
    >
      {props.metricName}
    </div>
  );
};

const { Colors } = TabStyles;

const titleStyle: React.CSSProperties = {
  color: Colors!.L9,
  fontSize: '24px',
  lineHeight: 'normal',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
